// Dependencies imports
import React, { useState } from 'react';
import { Tab } from "semantic-ui-react";


// Local imports
import {ReactComponent as Close} from '../../../assets/svg/close_black_24dp.svg';
import BatchLevel from './BatchLevel';
import CourseLevel from './CourseLevel';


// Style imports
import Course from "./CourseView.module.scss";

 

const CourseView = (props)=> {
    let {handleClose, courseView, name, loading} = props;
  console.log("courseview inside courseview", courseView);

    // Data for tabs
 const panes = [
  {
    menuItem: "Batch Level",
    render: () => (
      <Tab.Pane >
        <BatchLevel courseView={courseView} loading={loading}/>
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Course Level",
    render: () => (
      <Tab.Pane active={true} >
        <CourseLevel courseView={courseView} loading={loading}/>
      </Tab.Pane>
    ),
  }
];
    

    


    return(
        <div className={Course.maincontainer}>
            <div className={Course.closeholder}>
                <Close onClick={handleClose} className={Course.closeicon} />
            </div>
            <div className={Course.instructurname}>
                <h3>Live sessions - {name}</h3>
            </div>
            <div className={Course.tabsholder}>
                <Tab panes={panes}/>
            </div>
        </div>
    );
};

export default CourseView;